import { connect } from 'react-redux';
import Future, {
  Props,
} from '@/components/DeprecatedPortfolio/components/Future';
import { portfolioSelector } from '@/components/DeprecatedPortfolio/redux/selectors';
import { get } from 'lodash';
import { getFutureSelector } from '../redux/selectors';

type StateProps = Omit<Props, 'sectionNumber'>;

const mapStateToProps = (state, ownProps): StateProps => {
  const portfolio = portfolioSelector(state);
  const future = getFutureSelector(state, {
    ...ownProps,
    industryId: 0,
    marketISO2: get(portfolio, ['marketISO2'], ''),
  });

  return {
    portfolioId: future.portfolioId,
    portfolioName: future.portfolioName,
    secretCode: future.secretCode,
    expectedAnnualEarningsGrowthRateFormatted:
      future.expectedAnnualEarningsGrowthRateFormatted,
    pastAverageEarningsGrowthRateFormatted:
      future.pastAverageEarningsGrowthRateFormatted,
    marketEarningsGrowthRateFormatted: future.marketEarningsGrowthRateFormatted,
    expectedRevenueGrowthRateFormatted:
      future.expectedRevenueGrowthRateFormatted,
    pastAverageRevenueGrowthRateFormatted:
      future.pastAverageRevenueGrowthRateFormatted,
    marketRevenueGrowthRateFormatted: future.marketRevenueGrowthRateFormatted,

    marketName: future.marketName,
    expectedAnnualEarningsGrowthRate: future.expectedAnnualEarningsGrowthRate,
    pastAverageEarningsGrowthRate: future.pastAverageEarningsGrowthRate,
    marketEarningsGrowthRate: future.marketEarningsGrowthRate,
    expectedRevenueGrowthRate: future.expectedRevenueGrowthRate,
    pastAverageRevenueGrowthRate: future.pastAverageRevenueGrowthRate,
    marketRevenueGrowthRate: future.marketRevenueGrowthRate,
  };
};

type ContainerProps = Pick<Props, 'sectionNumber'>;
export default connect<StateProps, unknown, ContainerProps>(mapStateToProps)(
  Future
);
